const hasOwnValue = field => Object.prototype.hasOwnProperty.call(field, "value");

const workflowOptionId = value => {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value.id;
  }

  return value;
};

const workflowFieldObject = (object, field) => {
  if (!hasOwnValue(field)) {
    return object;
  }

  return { ...object, [field.name]: field.value };
};

const workflowSelectDefaultValues = (value, multiple) => {
  const values = multiple ? (Array.isArray(value) ? value : []) : [value];

  return values.map(workflowOptionId).filter(id => id !== null && id !== undefined);
};

const findWorkflowOption = (options, value) => {
  const id = workflowOptionId(value);

  return options.find(option => option.id === id);
};

const workflowSelectInitialValue = (value, options, multiple) => {
  if (multiple) {
    if (!Array.isArray(value)) {
      return [];
    }

    return value.map(item => findWorkflowOption(options, item)).filter(option => option !== undefined);
  }

  return findWorkflowOption(options, value) || null;
};

const workflowSelectPayload = (value, multiple) => {
  if (multiple) {
    return Array.isArray(value) ? value.map(workflowOptionId) : [];
  }

  if (value === null || value === undefined) {
    return undefined;
  }

  return workflowOptionId(value);
};

const workflowSelectHasValue = (value, multiple) => {
  return multiple ? Array.isArray(value) && value.length > 0 : value !== null && value !== undefined;
};

module.exports = {
  workflowFieldObject,
  workflowOptionId,
  workflowSelectDefaultValues,
  workflowSelectHasValue,
  workflowSelectInitialValue,
  workflowSelectPayload,
};
